// extracted by mini-css-extract-plugin
export default {"title":"StackTraceBanner_title__eUnbN"};